/*
 * Style File - jQuery plugin for styling file input elements
 *
 * Copyright (c) 2007-2008 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Based on work by Shaun Inman
 *   http://www.shauninman.com/archive/2007/09/10/styling_file_inputs_with_css_and_the_dom
 *
 * Revision: $Id: jquery.filestyle.js 303 2008-01-30 13:53:24Z tuupola $
 *
 */

(function ($) {

    $.fn.filestyle = function (options) {

        /* TODO: This should not override CSS. */
        var settings = {
            fieldWidth: 250,
            fieldDisplay: 'inline',
            classNamePrefix: 'file-style'
        };

        if (options) {
            $.extend(settings, options);
        };

        return this.each(function () {

            var self = this;
            var wrapper = $('<div class="' + settings.classNamePrefix + '-wrapper">')
            .css($.extend({
                "width": settings.imageWidth + "px",
                "height": settings.imageHeight + "px",
                //        "background": "url(" + settings.imagePath + ") 0 0 no-repeat",
                "background-position": "right",
                "display": "inline",
                "position": "absolute",
                "top": "0.0",
                "left":"0.0",
                "overflow": "hidden"
            }, settings.imageCss));

            var filename = $('<input class="file ' + settings.classNamePrefix + '-file">')
            .attr('readonly', 'true')
            .addClass($(self).attr("class"))
            .css({
                "display": settings.fieldDisplay,
                "width": settings.fieldWidth + "px"
            });

            $(self).before(filename);
            $(self).wrap(wrapper);

            $(self).css({
                "position": "relative",
                "height": settings.imageHeight + "px",
                "display": "inline",
                "cursor": "pointer",
                "opacity": "0.0"
            });

         $(self).css("margin-left", settings.imageWidth - settings.fieldWidth + "px");

            $(self).bind("change",
            function () {
                filename.val($(self).val().replace(/(c:\\)*fakepath\\/i, ''));
            });

        });


    };

})(jQuery);
